import React from "react";

const Header = ({ title }) => (
  <div className="p-3 text-white">
    <div className="d-flex justify-content-between align-items-center ">
    </div>
    <h1 className="fs-2 fw-semibold">{title}</h1>
  </div>
);

export default Header;
